import { motion } from "framer-motion";

export default function Marquee({ items, reverse = false, accent = false }) {
  const repeated = [...items, ...items];
  return (
    <div className="marquee-mask overflow-hidden py-6 border-y border-white/5">
      <div
        className={`flex gap-12 whitespace-nowrap ${
          reverse ? "animate-marquee-rev" : "animate-marquee"
        }`}
      >
        {repeated.map((item, i) => (
          <span
            key={i}
            className={`font-display font-black uppercase tracking-tight text-5xl md:text-7xl ${
              accent
                ? "gradient-gold-text"
                : "text-white/10"
            }`}
            style={{
              WebkitTextStroke: accent ? undefined : "1px rgba(255,255,255,0.25)",
              color: accent ? undefined : "transparent",
            }}
          >
            {item}
            <span className="mx-6 text-agency-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
